/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC, ReactNode, useEffect, useState } from 'react'
import { Empty, Input, Modal } from 'antd'
import BaseSelector, { BaseSelectorOption } from './BaseSelector'

const InputWithBaseSelector: FC<{
 disabled?: boolean
 value?: BaseSelectorOption[]
 onChange?: (v: BaseSelectorOption[]) => void
 isLoading: boolean
 hasMore?: boolean
 fetchMore: () => void
 flatData?: {
  id: number
  name: string
 }[]
 setSearchKey: React.Dispatch<React.SetStateAction<string>>
 placeholder?: {
  input?: string
  folder?: string
 }
 type: 'single' | 'multiple'
 titleNode?: ReactNode
}> = ({
 fetchMore,
 disabled,
 isLoading,
 setSearchKey,
 flatData,
 hasMore,
 onChange,
 value,
 placeholder,
 type,
 titleNode,
}) => {
 const [showModal, setShowModal] = useState(false)

 const [selected, setSelected] = useState<BaseSelectorOption[]>(value ?? [])
 const [selectedValue, setSelectedValue] = useState<BaseSelectorOption[]>(
  value ?? [],
 )
 useEffect(() => {
  if (value) {
   setSelectedValue(value)
   setSelected(value)
  }
 }, [value])

 return (
  <>
   {type === 'single' ? (
    <Input
     disabled={disabled}
     value={selectedValue?.[0]?.title ?? ''}
     onFocus={() => {
      if (!disabled) {
       setShowModal(true)
      }
     }}
     placeholder={placeholder?.input ?? ''}
    />
   ) : (
    <div
     className="base-selecter-multi-input"
     style={{ paddingLeft: value?.length ? '4px' : '12px' }}
     onClick={() => setShowModal(true)}
    >
     {value?.length ? (
      value?.map((i, n) => (
       <span
        className="multi-input-item"
        key={n}
        onClick={(e) => {
         e?.stopPropagation()
        }}
       >
        <span className="multi-input-item-txt">{i?.title}</span>
        <span
         className="multi-input-item-icon"
         onClick={() => {
          onChange?.(value?.filter((v) => v?.title !== i?.title))
         }}
        >
         <i className="far fa-times" />
        </span>
       </span>
      ))
     ) : (
      <span className="placeholder">{placeholder?.input ?? ''}</span>
     )}
    </div>
   )}
   {showModal && (
    <Modal
     onCancel={() => setShowModal(false)}
     visible={showModal}
     title={titleNode ?? placeholder?.folder ?? ''}
     bodyStyle={{ padding: 0 }}
     onOk={() => {
      onChange?.(selected)
      setSelectedValue(selected)
      setShowModal(false)
     }}
    >
     <BaseSelector
      type={type}
      isLoading={isLoading}
      onSearch={setSearchKey}
      options={flatData?.map((v) => ({ title: v?.name, id: v?.id }))}
      value={selected}
      searchPlaceholder={placeholder?.folder ?? ''}
      onChange={(e) => setSelected(e)}
      fetchMore={fetchMore}
      hasMore={hasMore}
      showEmpty={!isLoading && flatData?.length === 0}
     />
    </Modal>
   )}
  </>
 )
}

export default InputWithBaseSelector
